export default "__VITE_ASSET__DdW3P2ss__ 100w";